import { render, staticRenderFns } from "./CCustomSelect.vue?vue&type=template&id=04ae4516&"
import script from "./CCustomSelect.vue?vue&type=script&lang=ts&"
export * from "./CCustomSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports